import { gql } from '@apollo/client'

import { usePaginatedQuery } from 'hooks'

const FORM_SUBMISSION_LIST_QUERY = gql`
  query FormSubmissionList($offset: Int, $max: Int) {
    formSubmissionList(offset: $offset, max: $max) {
      totalCount
      results {
        id
        user {
          entity {
            sector {
              name
            }
          }
        }
        dateCreated
        score
      }
    }
  }
`

export const useFormSubmissionListQuery = opts =>
  usePaginatedQuery(FORM_SUBMISSION_LIST_QUERY, opts)
